import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";


class AlmacenesService {

    /**
     * Obtener almacenes
     * @returns {Promise<any>}
     */
    static async obtenerAlmacenes(todos = false) {
        try {
            const query = todos ? '?estados=todos' : '';
            const url = HostService.getHost() + 'almacenes' + query;
            const response = await axios.get(url, AuthService.setToken());
            return response.data;
        } catch (err) {
            console.error('Error al obtener almacenes:', err.message);
            throw err;
        }
    }

}

export default AlmacenesService;